<template>
    <b-row>
        <b-col v-for="(status, index) in statusLista" :key="status">
            <app-box
                :titulo="`${status} (${totaisLista[index].qtd})`"
                :corBox="corBox(status)"
                :corTexto="corTexto(status)"
                >{{ totaisLista[index].valor | currency }}</app-box
            >
        </b-col>
    </b-row>
</template>

<script>
export default {
    props: {
        totaisStatus: {
            type: Object,
            default: () => {}
        }
    },

    methods: {
        corTexto(status) {
            switch (status) {
                case 'CONCLUÍDO':
                    return 'success'
                    break
                case 'REPROVADO':
                    return 'danger'
                    break
                case 'REPROVADO PELO SETOR FINANCEIRO':
                    return 'danger'
                    break
                case 'CRIADO':
                    return 'secondary'
                    break
                case 'EM PROCESSAMENTO PELO SETOR FINANCEIRO':
                    return 'warning'
                    break
                case 'EM ANÁLISE':
                    return 'warning'
                    break
                default:
                    break
            }
            return 'primary'
        },

        corBox(status) {
            return this.corTexto(status)
        }
    },

    computed: {
        statusLista() {
            return Object.keys(this.totaisStatus)
        },

        totaisLista() {
            return Object.values(this.totaisStatus)
        }
    }
}
</script>
